
tower.suggestConfig = (textarea) ->
  return false unless textarea.data('suggest')
  return {
    url: textarea.data('suggest')
    nameKey: 'title'
    itemRenderer: ($item, data) ->
      $item.prepend "<small>##{data.team_wide_id}</small>" if data.team_wide_id
      return $item
    linkRenderer: ($link, data) ->
      $link.attr 'href', data.uri
      $link.text("##{data.team_wide_id} #{data.title}") if data.team_wide_id
  }
